import { useEffect, useState } from "react";
import Question from "../pages/Question";
import Information from "../pages/Information";
import LifeStyle from "../pages/LifeStyle";
import MedicalRecords from "../pages/MedicalRecords";
import MedicalRecords2 from "../pages/MedicalRecords2";
import MedicalRecords3 from "../pages/MedicalRecords3";
import MedicalRecords4 from "../pages/MedicalRecords4";

const HomeComponent = () => {
  const [Step, setStep] = useState(localStorage.getItem("step") || 1);
  useEffect(() => {
    setStep(parseInt(localStorage.getItem("step")) || 1);
  }, []);
  return (
    <div>
      {Step === 1 ? (
        <Question step={Step} setStep={setStep} />
      ) : Step === 2 ? (
        <Information step={Step} setStep={setStep} />
      ) : Step === 3 ? (
        <LifeStyle step={Step} setStep={setStep} />
      ) : Step === 4 ? (
        <MedicalRecords step={Step} setStep={setStep} />
      ) : Step === 5 ? (
        <MedicalRecords2 step={Step} setStep={setStep} />
      ) : Step === 6 ? (
        <MedicalRecords3 step={Step} setStep={setStep} />
      ) : Step === 7 ? (
        <MedicalRecords4 step={Step} setStep={setStep} />
      ) : (
        ""
      )}
    </div>
  );
};

export default HomeComponent;
